export const ConstantesCXPI = {} as const
export const ConstantesCIPI = {
  ...ConstantesCXPI,
  dureeMinMissionEnHeure: 70
} as const
export const ConstantesCDPI = {
  ...ConstantesCXPI,
} as const
